import * as React from 'react';
import {VideoValue} from 'api/lesson/types';
import {FileObject, getFilePath} from 'api/library';
import Container from 'containers/Container';
import FileContainer from './components/FileContainer';
import VideoPlayer from 'components/VideoPlayer';

export interface VideoTemplateProps {
  value?: VideoValue;
}

/**
 * This is the video block of the lesson viewer.
 * @param {VideoTemplateProps} props
 * @return {React.ReactElement<VideoTemplateProps> | null}
 * @constructor
 */
export default function VideoTemplate(
    props: VideoTemplateProps,
): React.ReactElement<VideoTemplateProps> | null {
  /**
   * the function render VideoPlayer
   * @param {FileObject} file
   * @return {React.ReactElement<VideoTemplateProps> | null}
   * @constructor
   */
  function renderVideo(file: FileObject) {
    const src = getFilePath(file.id);

    return <VideoPlayer src={src} />;
  }

  return props.value ? (
    <Container>
      <FileContainer id={props.value}>
        {(file) => renderVideo(file)}
      </FileContainer>
    </Container>
  ) : null;
}
